/**
 * Normalize free-text answers (Tamil + mixed Latin) for comparison.
 * - trims ends
 * - lowercases (Latin letters)
 * - removes common punctuation / symbols
 * - collapses internal whitespace to a single space
 */
const PUNCT_RE =
  /['!"#$%&()*+,\-./:;<=>?@[\]^_`{|}~。、，・\\।॥…\u2000-\u206F\u2E00-\u2E7F\u3000-\u303F]/g;

export function normalizeTamilAnswer(raw: string): string {
  let s = raw.normalize('NFC').trim().toLowerCase();
  s = s.replace(/\s+/g, ' ');
  s = s.replace(PUNCT_RE, '');
  s = s.replace(/\s+/g, ' ').trim();
  return s;
}

/** True if normalized student string exactly matches any accepted option. */
export function tamilAnswerExactMatch(student: string, acceptedAnswers: string[]): boolean {
  const n = normalizeTamilAnswer(student);
  if (!n) return false;
  return acceptedAnswers.some((a) => normalizeTamilAnswer(a) === n);
}

/**
 * Flexible match when exact fails: normalized accepted phrase contained in student answer,
 * or student answer contained in accepted (for short student replies).
 * Skips very short accepted strings to reduce false positives.
 */
export function tamilAnswerFlexibleMatch(student: string, acceptedAnswers: string[]): boolean {
  const n = normalizeTamilAnswer(student);
  if (!n) return false;
  for (const a of acceptedAnswers) {
    const na = normalizeTamilAnswer(a);
    if (na.length < 2) continue;
    if (n.includes(na) || na.includes(n)) return true;
  }
  return false;
}

/** Exact match first, then flexible contains-style match. */
export function isTamilAnswerAccepted(student: string, acceptedAnswers: string[]): boolean {
  if (!acceptedAnswers.length) return false;
  if (tamilAnswerExactMatch(student, acceptedAnswers)) return true;
  return tamilAnswerFlexibleMatch(student, acceptedAnswers);
}
